import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectUsersState = (state) => state.creatorsVerification || initialState;

export const getCreatorsInstagramInfo = createSelector(
    [selectUsersState],
    (usersState) => usersState.creatorsInstagramInfo
);

export const getVerifyInfo = createSelector(
    [selectUsersState],
    (usersState) => usersState.verifyInfo
);